import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  padding: 150px 32px 32px 32px;
  align-items: center;
`;

export const Text = styled.p`
  color: #000;
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 24px */
`;

export const Title = styled.p`
  color: #000;
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
`;

export const SpaceX: any = styled.div`
  width: ${(props: any) => props?.space}px;
`;

export const SpaceY: any = styled.div`
  height: ${(props: any) => props?.space}px;
`;

export const RowSpace: any = styled.div`
  display: flex;
  flex-direction: row;
  align-items: end;
  justify-content: space-between;
`;

export const CardOverflow: any = styled.div`
  flex-shrink: 1;
  border-radius: 9.843px;
  background: #fff;
  box-shadow: 0px 1.85px 9.24px 0px rgba(0, 0, 0, 0.1);
  padding: 16px;
  overflow: auto;

  /* Estilização da scrollbar */
  &::-webkit-scrollbar {
    width: 6px; /* Largura da scrollbar */
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.2); /* Cor da barra de rolagem */
    border-radius: 3px; /* Bordas arredondadas */
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.3); /* Cor ao passar o mouse */
  }

  &::-webkit-scrollbar-track {
    background: transparent; /* Fundo da track */
  }
`;

export const CardCenter: any = styled.div`
  flex-shrink: 1;
  border-radius: 9.843px;
  background: #fff;
  box-shadow: 0px 1.85px 9.24px 0px rgba(0, 0, 0, 0.1);
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 700px;
  max-width: 700px;
`;

export const Badge: any = styled.div`
  display: flex;
  flex-direction: row;
  background-color: #eaefff;
  padding: 8px 22px;
  border-radius: 30px;
  align-items: center;
  gap: 16px;
`;

export const BadgeText: any = styled.p`
  color: var(--Azul-Primary-500, #2d5bff);
  font-family: Inter;
  font-size: 27.158px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;
